import React from "react";

export const validateInputText = (id, text) => {
    return <small id={id} className="p-invalid p-d-block" style={{color:"#FF0000"}}>{`กรุณาระบุ ${text}`}</small>;
};

export const validateRdo = (id, text) => {
    return <small id={id} className="p-invalid p-d-block" style={{color:"#FF0000"}}>{`กรุณาเลือก ${text}`}</small>;
};

export const validateInputTextCus = (id, text) => {
    return <small id={id} className="p-invalid p-d-block" style={{color:"#FF0000"}}>{`${text}`}</small>;
};

